import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import { Button, Collapse, Input, List, Tabs, Typography, Tag, Divider, Icon } from 'antd';
import GlobalStateContext from '../../../../context';
import Paragraph from 'antd/lib/typography/Paragraph';
import MediaPannelDesign from './MediaPannelDesign';
import MediapanelWebService from '../../../../classes/MediapanelWebService';
import StreamWebService from '../../../../classes/StreamWebService';
import MusicPanel from './music/MusicPanel';
import './MediaPannel.css';
import { update } from 'lodash';
import MediaPannelBanner from './mediaPannelBanners/MediaPannelBanner';
import MediaPannelBanners from './MediaPannelBanners';
import StreamChat from '../../../../components/StreamChat';
import IconTabBar from './IconTabBar';
import MediaEnhancementsPanel from './MediaEnhancementsPanel';
import { BsPalette, BsChatDots, BsMusicNote, BsTextParagraph, BsStars } from 'react-icons/bs';

const { Title, Text } = Typography;

function MediaPannel(props) {
    const { item, streamState } = props;
    const { Panel } = Collapse;
    const [activeTab, setActiveTab] = useState(null);

    const [gState, dispatch] = useContext(GlobalStateContext);
    const [panelData, setPanelData] = useState(gState?.mediaPanel || {});
    const wbs = new MediapanelWebService()
    const sWbs = new StreamWebService()
    const isInitialRender = useRef(true);

    const callback = (index) => {
        console.log(index);
    }

    const getMediaPanels = () => {
        wbs.getMediapanels().then(res => {
            console.log("[x] Media panels loaded", res.data)
            console.log("[x] Available fonts:", res.data?.fonts)
            setPanelData(res.data)
            dispatch({
                type: "SET_ITEM",
                payload: ['mediaPanel', { ...res.data }]
            })
        })
    }

    const addMediaPannelItem = (type, item) => {
        console.log("Adding media panel item", type, item)
        wbs.add(type, item).then(res => {
            console.log("[x] Media panel saved", res)
            getMediaPanels()
        }).catch(err => {
            console.error("Failed to save media panel", err)
        })
    }

    const handleDelete = (type, item) => {
        console.log("Deleting media panel item", type, item)

        // If the deleted item is currently in use, remove it from the stream config
        if (streamState) {
            if (type === "logos" && streamState?.logo?.url === item.url) {
                handleConfigUpdate({ ...streamState, ...item?.config, logo: null });
            } else if (type === "backgrounds" && streamState?.background?.url === item.url) {
                handleConfigUpdate({ ...streamState, ...item?.config, background: null });
            } else if (type === "videos" && streamState?.video?.url === item.url) {
                handleConfigUpdate({ ...streamState, ...item?.config, video: null });
            } else if (type === "banners" && streamState?.banners) {
                // Remove the deleted banner from active banners array
                const updatedBanners = streamState.banners.filter(banner => banner.name !== item.name);
                handleConfigUpdate({ ...streamState, ...item?.config, banners: updatedBanners });
            }
            // If the deleted item is currently being presented, stop presenting
            if (streamState?.sharedMedia?.url === item?.url) {
                handleConfigUpdate({ ...streamState, sharedMedia: null });
            }
        }

        // Also delete from backend
        wbs.deleteItem(type, item).then(res => {
            console.log("[x] Media panel item deleted", res)
            getMediaPanels();
        }).catch(err => {
            console.error("Failed to delete media panel item", err)
        })
    };

    const handlePresentMedia = (type, item) => {
        console.log("Presenting media item", type, item)
        const sharedMediaData = {
            ...item,
            type: type,
            presenterName: gState?.user?.name || "Moderator",
            presentedAt: new Date().toISOString()
        };
        const newConfig = {
            ...streamState,
            sharedMedia: sharedMediaData
        };
        handleConfigUpdate(newConfig);

        // Immediate sync for all participants
        if (gState?.io && (props.item?.user === gState?.user?._id)) {
            gState.io.emit(`stageStateUpdated_${props.item?.id}`, newConfig);
        }
    };

    const handleStopPresenting = () => {
        console.log("Stopping media presentation")
        const newConfig = {
            ...streamState,
            sharedMedia: null
        };
        handleConfigUpdate(newConfig);

        // Immediate sync for all participants
        if (gState?.io && (props.item?.user === gState?.user?._id)) {
            gState.io.emit(`stageStateUpdated_${props.item?.id}`, newConfig);
        }
    };
    useEffect(() => {
        getMediaPanels()
    }, [])


    // Handle stream config updates from MediaPannelDesign
    const handleConfigUpdate = useCallback((newConfig) => {
        console.log("[MediaPannel] Updating stream config:", newConfig);
        // Update the stream state in the parent component
        if (props.onStreamStateUpdate) {
            props.onStreamStateUpdate(newConfig);
        }

        // Update the stream configuration in the backend
        if (newConfig.stream_id) {
            sWbs.updateConfig(newConfig.stream_id, newConfig)
                .then(response => {
                    console.log("[MediaPannel] Stream config updated successfully:", response);
                })
                .catch(error => {
                    console.error("[MediaPannel] Failed to update stream config:", error);
                });
        }
    }, [props.onStreamStateUpdate]);



    const handleTabChange = (tabKey) => {
        // Toggle tab - if clicking the same tab, close it
        setActiveTab(activeTab === tabKey ? null : tabKey);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'design':
                return (
                    <div className="tab-content-wrapper">
                        <div className="tab-content-header">
                            <BsPalette className="tab-header-icon" />
                            <div className="tab-header-text">
                                <h3>Design & Branding</h3>
                                <p>Customize your stream's visual appearance</p>
                            </div>
                        </div>
                        <div className="tab-content-body">
                            <MediaPannelDesign
                                designs={panelData}
                                active={item?.config}
                                stream_id={item?.id}
                                state={streamState || item?.config || {}}
                                onConfigUpdate={handleConfigUpdate}
                                onAdd={(type, item) => addMediaPannelItem(type, item)}
                                onDelete={handleDelete}
                                onPresentMedia={handlePresentMedia}
                                onStopPresenting={handleStopPresenting}
                            />
                        </div>
                    </div>
                );
            case 'captions':
                return (
                    <div className="tab-content-wrapper">
                        <div className="tab-content-header">
                            <BsTextParagraph className="tab-header-icon" />
                            <div className="tab-header-text">
                                <h3>Captions & Banners</h3>
                                <p>Add text overlays and scrolling banners</p>
                            </div>
                        </div>

                        {/* Labels Toggle Section */}
                        {props.toggleLabels && (
                            <div style={{
                                padding: '12px 20px',
                                background: '#ffffff',
                                borderBottom: '1px solid #e5e7eb'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: '12px'
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#1f2937',
                                            marginBottom: '4px'
                                        }}>
                                            Stream Labels
                                        </div>
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#6b7280',
                                            lineHeight: '1.4'
                                        }}>
                                            {props.showLabels ? 'Name tags are visible on streams' : 'Name tags are hidden'}
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => {
                                            console.log('Labels toggle clicked from MediaPanel, showLabels:', props.showLabels);
                                            props.toggleLabels();
                                        }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            padding: '8px 16px',
                                            background: props.showLabels ? '#3b82f6' : '#e5e7eb',
                                            color: props.showLabels ? 'white' : '#6b7280',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            boxShadow: props.showLabels ? '0 2px 8px rgba(59, 130, 246, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.05)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                            e.currentTarget.style.boxShadow = props.showLabels
                                                ? '0 4px 12px rgba(59, 130, 246, 0.3)'
                                                : '0 2px 6px rgba(0, 0, 0, 0.08)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = props.showLabels
                                                ? '0 2px 8px rgba(59, 130, 246, 0.2)'
                                                : '0 1px 3px rgba(0, 0, 0, 0.05)';
                                        }}
                                    >
                                        <Icon type={props.showLabels ? 'eye' : 'eye-invisible'} />
                                        <span>{props.showLabels ? 'Visible' : 'Hidden'}</span>
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="tab-content-body">
                            <MediaPannelBanners
                                active={streamState.banners || []}
                                stream_id={item?.id}
                                onAdd={(type, item) => addMediaPannelItem(type, item)}
                                onDelete={handleDelete}
                                banners={panelData?.banners || []}
                                onConfigUpdate={handleConfigUpdate}
                                config={streamState || item?.config || {}}
                            />
                        </div>
                    </div>
                );
            case 'enhancements':
                return (
                    <div className="tab-content-wrapper">
                        <div className="tab-content-header">
                            <BsStars className="tab-header-icon" />
                            <div className="tab-header-text">
                                <h3>Media Enhancements</h3>
                                <p>Apply video and audio effects to your stream</p>
                            </div>
                        </div>
                        <div className="tab-content-body">
                            <MediaEnhancementsPanel
                                mediaPipeline={props.mediaPipeline}
                                isModerator={props.isModerator}
                                enhancementsAllowed={props.enhancementsAllowed}
                                onPermissionChange={props.onEnhancementsPermissionChange}
                                onPerformanceModeChange={props.onPerformanceModeChange}
                                performanceMode={props.performanceMode}
                            />
                        </div>
                    </div>
                );
            case 'music':
                return (
                    <div className="tab-content-wrapper">
                        <div className="tab-content-header">
                            <BsMusicNote className="tab-header-icon" />
                            <div className="tab-header-text">
                                <h3>Sound & Music</h3>
                                <p>Manage background music and audio tracks</p>
                            </div>
                        </div>
                        <div className="tab-content-body">
                            <MusicPanel
                                onMusicUpdate={handleConfigUpdate}
                                currentMusic={streamState?.music || {}}
                                musicLibrary={panelData?.music || []}
                                onUpload={(type, item) => addMediaPannelItem(type, item)}
                                onDelete={handleDelete}
                            />
                        </div>
                    </div>
                );
            case 'chat':
                return (
                    <div className="tab-content-wrapper">
                        <div className="tab-content-header">
                            <BsChatDots className="tab-header-icon" />
                            <div className="tab-header-text">
                                <h3>Live Chat</h3>
                                <p>Interact with your viewers in real-time</p>
                            </div>
                        </div>
                        <div className="tab-content-body chat-tab-content">
                            <StreamChat stream={item} />
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="media-panel-with-icons">
            {/* Collapsible Panel Content */}
            <div className={`media-panel-content ${activeTab ? 'expanded' : 'collapsed'}`}>
                {activeTab && (
                    <div className="media-panel-content-inner">
                        {renderTabContent()}
                    </div>
                )}
            </div>

            {/* Icon Tab Bar */}
            <IconTabBar
                activeTab={activeTab}
                onTabChange={handleTabChange}
                pendingCount={0}
                isModerator={props.isModerator}
            />
        </div>
    )
}

export default MediaPannel;